import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import Day from '@redturtle/iovisit-theme/components/Views/Itinerary/Day';
import StepExpanded from '@redturtle/iovisit-theme/components/Views/Itinerary/StepExpanded';

const messages = defineMessages({
  OrdinalNumF_1: {
    id: 'OrdinalNumF_1',
    defaultMessage: 'Prima',
  },
  OrdinalNumF_2: {
    id: 'OrdinalNumF_2',
    defaultMessage: 'Seconda',
  },
  OrdinalNumF_3: {
    id: 'OrdinalNumF_3',
    defaultMessage: 'Terza',
  },
  OrdinalNumF_4: {
    id: 'OrdinalNumF_4',
    defaultMessage: 'Quarta',
  },
  OrdinalNumF_5: {
    id: 'OrdinalNumF_5',
    defaultMessage: 'Quinta',
  },
  OrdinalNumF_6: {
    id: 'OrdinalNumF_6',
    defaultMessage: 'Sesta',
  },
  OrdinalNumF_7: {
    id: 'OrdinalNumF_7',
    defaultMessage: 'Settima',
  },
  OrdinalNumF_8: {
    id: 'OrdinalNumF_8',
    defaultMessage: 'Ottava',
  },
  OrdinalNumF_9: {
    id: 'OrdinalNumF_9',
    defaultMessage: 'Nona',
  },
  OrdinalNumF_10: {
    id: 'OrdinalNumF_10',
    defaultMessage: 'Decima',
  },
  OrdinalNumF_11: {
    id: 'OrdinalNumF_11',
    defaultMessage: 'Undicesima',
  },
  OrdinalNumF_12: {
    id: 'OrdinalNumF_12',
    defaultMessage: 'Dodicesima',
  },
  OrdinalNumF_13: {
    id: 'OrdinalNumF_13',
    defaultMessage: 'Tredicesima',
  },
  OrdinalNumF_14: {
    id: 'OrdinalNumF_14',
    defaultMessage: 'Quattordicesima',
  },
  OrdinalNumF_15: {
    id: 'OrdinalNumF_15',
    defaultMessage: 'Quindicesima',
  },
});

const DayExpanded = ({ day, showLeadImage }) => {
  const intl = useIntl();

  return (
    <Day day={day} showLeadImage={false} className="day-expanded">
      {day.steps?.map((step, index) => {
        var number = messages['OrdinalNumF_' + (index + 1)];
        return (
          <StepExpanded
            step={step}
            number={number ? intl.formatMessage(number) : index + '°'}
            key={`step${index}`}
          />
        );
      })}
    </Day>
  );
};

DayExpanded.propTypes = {
  day: PropTypes.object.isRequired,
};

export default DayExpanded;
